import { useEffect, useState } from 'react';

const useDimension = () => {
  const [width, setWidth] = useState<number>(0);
  const [height, setHeight] = useState<number>(0);
  const isPortrait = width < height;
  const isSquareView = width === height;
  const updateDimension = () => {
    setWidth(window.innerWidth);
    setHeight(window.innerHeight);
  };
  useEffect(() => {
    updateDimension();

    window.addEventListener('resize', updateDimension);
    return () => {
      window.removeEventListener('resize', updateDimension);
    };
  }, []);
  return {
    width,
    height,
    isPortrait,
    isSquareView,
  };
};

export { useDimension };
